import * as React from "react";
import DataGrid from "../../app/grid/DataGrid";
import { Form, Spin } from "antd";
import { IReportingPeriodApplicantDocumentsPresenter } from "../../../../presenter/reporting/ReportingPeriodApplicantDocumentsPresenter";
import { IReportingPeriodApplicantDocument } from "../../../../model/document/ReportingPeriodApplicantDocument";
import CreateReportingPeriodApplicantDocumentForm, {
  CreateReportingPeriodApplicantDocumentFormProps
} from "./CreateReportingPeriodApplicantDocumentForm";
import UpdateReportingPeriodApplicantDocumentForm, {
  UpdateReportingPeriodApplicantDocumentFormProps
} from "./UpdateReportingPeriodApplicantDocumentForm";
import TickBox from "../../app/grid/TickBox";

export interface Props {}

export interface State extends IReportingPeriodApplicantDocumentsPresenter {}

export default class DocumentsGrid extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      documents,
      assignDocumentToForm,
      translate,
      removeDocument,
      updateDocument,
      allowedFileTypes
    } = this.state;

    const CreateReportingPeriodApplicantDocument =
      Form.create<CreateReportingPeriodApplicantDocumentFormProps>({})(
        CreateReportingPeriodApplicantDocumentForm
      );

    const UpdateReportingPeriodApplicantDocument =
      Form.create<UpdateReportingPeriodApplicantDocumentFormProps>({})(
        UpdateReportingPeriodApplicantDocumentForm
      );

    const columns = [
      {
        title: translate("form_version_document_form.name"),
        key: "name",
        render: (text, record) => {
          return record.valid ? (
            <a
              href={`/api/documents/${record.documentId}`}
              rel="noopener noreferrer"
            >
              {record.name}
            </a>
          ) : (
            <div>{record.name}</div>
          );
        },
        sorter: (a, b) => {
          return String(a.name).localeCompare(String(b.name));
        }
      },
      {
        title: translate("form_version_document_form.documentLink"),
        key: "document-link",
        render: (text, record) => (
          <div>
            {translate(
              `form_version_document_form.document_link_values.${record.documentRelation}`
            )}
          </div>
        )
      },
      {
        title: translate("form_version_document_form.valid"),
        key: "valid",
        render: (text, record) => <TickBox value={record.valid || false} />
      }
    ];
    return (
      <Spin spinning={this.state.loaders.documentLoader}>
        <DataGrid
          title={translate("form_version_document_form.title")}
          translate={translate}
          columns={columns}
          dataSource={documents}
          createForm={CreateReportingPeriodApplicantDocument}
          allowCreate={true}
          createModalTitle={translate(
            "form_version_document_form.create_modal_title"
          )}
          onCreate={(
            reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
          ) => {
            assignDocumentToForm(reportingPeriodApplicantDocument);
          }}
          updateModalTitle={translate(
            "form_version_document_form.update_modal_title"
          )}
          allowUpdate={true}
          updateForm={UpdateReportingPeriodApplicantDocument}
          onUpdate={(
            reportingPeriodApplicantDocument: IReportingPeriodApplicantDocument
          ) => {
            updateDocument(reportingPeriodApplicantDocument);
          }}
          allowDelete={true}
          deleteModalTitle={translate(
            "form_version_document_form.delete_modal_title"
          )}
          deleteModalMessage={translate(
            "form_version_document_form.delete_modal_message"
          )}
          onDelete={removeDocument}
          addButtonText={translate("form_version_document_form.add_btn_text")}
          horizontalScroll={false}
          addButtonStyle={{ marginBottom: 0 }}
          actionsColumnPosition={"left"}
          createButtonPosition={"left"}
          editableRecordProp={"valid"}
          codebooks={{ allowedFileTypes }}
        />
      </Spin>
    );
  }
}
